import React from 'react';
import './ManagerPopup.css';
import message2Icon from '../assets/icons/message2.svg';

const ManagerPopup = ({ 
  isOpen, 
  onClose, 
  supportLink 
}) => {
  if (!isOpen) return null;

  const handleSupportClick = () => {
    if (supportLink) {
      window.open(supportLink, '_blank', 'noopener,noreferrer');
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="popup-overlay" onClick={handleBackdropClick}>
      <div className="popup-content">
        <div className="popup-icon">
          <img src={message2Icon} alt="Сообщение" />
        </div>
        
        <h2 className="popup-title">Напишите менеджеру</h2>
        
        <div className="popup-description">
          <p>Основной курс — платный.<br/>
          Чтобы узнать подробнее, напишите нашему
          менеджеру в личные сообщения.<br/>
          Он всё подскажет и поможет<br/>
          получить индивидуальный план.</p>
        </div>
        
        <div className="popup-buttons">
          <button 
            className="popup-button popup-button-primary"
            onClick={handleSupportClick}
          >
            Написать менеджеру
          </button>
          
          <button 
            className="popup-button popup-button-secondary"
            onClick={onClose}
          >
            На главную
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManagerPopup; 